import * as types from '../mutation-types'
import { ajaxFun } from '../actions'

// initial state
const state = {
  info: {},
  flag: false,
  time: ''
}

// getters
const getters = {
  curche: state => state
}

// actions
const actions = {
  clearCurche ({ commit }) {
    commit(types.CLEAR_CURCHE)
  },

  receiveCurche ({ commit, state }, para) {
    ajaxFun({commit, state}, para, state.flag, state.time, types.RECEIVE_CURCHE)
  }
}

// mutations
const mutations = {
  [types.RECEIVE_CURCHE] (state, curche) {
    state.info = curche
    state.flag = true
    state.time = new Date().getTime()
  },

  [types.CLEAR_CURCHE] (state) {
    state.flag = false
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/vuex/modules/curche.js